<template>
    <div v-if="mostrar" class="modal-mask" @click.self="$emit('fechar')">
        <div class="jm margem" style="min-width: 30vw; max-height: 80vh; overflow: auto;" @click.stop>
            <div class="alinha-centro">
                <h3>Cadastrar {{ tipo }}</h3>
            </div>
            <table class="tabela">
                <tbody>
                    <tr>
                        <th>nome</th>
                        <th></th>
                    </tr>
                    <tr v-for="item in lista" :key="item.id">
                        <td style="text-align: left">{{ item.nome }}</td>
                        <td><i class="bi-trash-fill" @click="$emit('excluir', item.id)"></i></td>
                    </tr>
                    <tr>
                        <td colspan="2">
                            <input type="text" placeholder="Novo item" @keyup.enter="onCadastrar($event)">
                        </td>
                    </tr>
                </tbody>
            </table>
        </div>
    </div>
</template>

<script>
export default {
    name: "ModalCadastrarItemOsTablets",
    props: {
        mostrar: { type: Boolean, default: false },
        tipo: { type: String, default: "" },
        lista: { type: Array, default: () => [] },
    },
    emits: ["fechar", "cadastrar", "excluir"],
    methods: {
        onCadastrar(event) {
            const valor = event?.target?.value?.trim();
            if (valor) {
                this.$emit("cadastrar", valor);
                event.target.value = "";
            }
        },
    },
};
</script>
